<template>
	<div class="messages">
		<div class="row">
			<div class="col-5 mb-4">
				<h1>My Activity Log</h1>
			</div>
			<div class="col-7 d-lg-none mb-4">
				<button class="btn btn-secondary float-right mb-2 ml-2"><b-icon icon="arrow-clockwise"></b-icon></button>
				<button class="float-right btn btn-primary" @click="shownew=true"><b-icon icon="pencil-square"></b-icon> {{
					$t("new")
				}}</button>
			</div>
			<div class="d-none d-lg-inline col-7">
				<button class="btn btn-secondary float-right mb-2 ml-2"><b-icon icon="arrow-clockwise"></b-icon></button>
				<button class="float-right btn btn-primary" @click="shownew=true"><b-icon icon="pencil-square"></b-icon> {{
					$t("new")
				}}</button>
				<input
					type="search"
					:placeholder="$t('search-messages-ellipses')"
					class="block float-right mr-4 form-control inline w-auto"
					:value="searchTerm"
					@input="searchTerm = $event.target.value"
					@keyup="searchTermChange"
					@search="searchTermChange"
				/>
			</div>
			<div class="col-12 d-lg-none mb-4">
				<input
					type="search"
					:placeholder="$t('search-ellipses')"
					class="block w-full form-control"
					:value="searchTerm"
					@input="searchTerm = $event.target.value"
					@keyup="searchTermChange"
					@search="searchTermChange"
				/>
			</div>
		</div>


		<div class="row">
			<div class="col-md-8">

				<!-- Activity Log -->
				<ScrollPaginator
					:data="activities"
					:submitting="submitting"
					:filters="filters"
					@toPage="toPage"
				>
					<template v-slot:item="{ item: activity }">
						<LogItem :activity="activity" @click="$router.push(`/reflections/view/${activity.id}`)" />
					</template>
 				</ScrollPaginator>

			</div>

			<div class="col-md-4">
				<!-- Messages -->
				<MessagesWidget limit="3" unread="1" class="mb-4"></MessagesWidget>

				<!-- Forms -->
				<FormsWidget list="requiringattention" limit="5" :header="$t('action-required')" class="mb-4"></FormsWidget>

				<!-- Timetable -->
				<div class="mb-4" v-if="$config.hasModule('timetable') && !isTeacher && $UserSession.hasPriv('TIMETABLE_VIEW')">
					<TimetableWidget />
				</div>

				<RecentlyMarkedWidget limit="3" v-if="$UserSession.hasPriv('TREATMENTSESSION_EDIT') && !isTeacher" />
			</div>
		</div>

		<MenuModal :show="shownew" @close="shownew = false" />

	</div>
</template>

<script>
import MessagesWidget from "src/components/widgets/MessagesWidget";
import FormsWidget from "src/components/widgets/FormsWidget"
import RecentlyMarkedWidget from "src/components/widgets/RecentlyMarkedWidget";
import TimetableWidget from "src/components/widgets/TimetableWidget";
import ScrollPaginator from "src/components/Table/ScrollPaginator";
import LogItem from "../../components/Reflections/LogItem.vue";
import MenuModal from "../../components/Workflows/MenuModal.vue";

export default {
	components: {
    MessagesWidget,
    FormsWidget,
    RecentlyMarkedWidget,
    TimetableWidget,
    ScrollPaginator,
    LogItem,
    MenuModal
},
	data() {
		return {
			searchTerm: null,
			shownew: false,
			activities: [],
			submitting: false,
			filters: {
				page: 1,
				page_size: 5,
			}
		};
	},
	mounted() {
		this.listActivities()
	},
	methods: {
		listActivities() {
			if (this.submitting) return
			this.submitting = true

			this.$cfetch(`${this.$settings.APIBaseURL}/activitylog/list`, {
				method: 'POST',
				data: this.filters,
			}).then(this.$assertApiSuccess).then(res => {
				this.activities = res.results
				this.filters.page = res.pagination.page
				this.filters.page_size = res.pagination.page_size
                this.filters.total = res.pagination.total
			}).catch(err => {
				this.$showApiError(err, { fallback: 'error-fetching-reflections' })
			}).finally(() => {
				this.submitting = false
			})
		},
		searchTermChange: function(){

		},
        toPage(pageNo) {
            this.filters.page = pageNo
            this.listActivities()
        }
	},
	computed: {
		isTeacher: function() {
			return this.$UserSession.hasPriv.call(this, "APP_TEACHER");
		},
	},
};
</script>
